import React, { createContext, useContext, useState, useCallback } from "react"

const FieldClipboardContext = createContext(null)

export function FieldClipboardProvider({ children }) {
  const [clipboard, setClipboard] = useState(null)
  const [draggedField, setDraggedField] = useState(null)

  const copyField = useCallback((field, value, fieldType) => {
    setClipboard({
      field,
      value,
      fieldType,
      timestamp: Date.now()
    })
  }, [])

  const pasteField = useCallback(() => {
    return clipboard
  }, [clipboard])

  const clearClipboard = useCallback(() => {
    setClipboard(null)
  }, [])

  const canPaste = useCallback((targetFieldType) => {
    if (!clipboard) return false
    // Allow paste only if field types match
    return clipboard.fieldType === targetFieldType
  }, [clipboard])

  const startDrag = useCallback((field, value, fieldType) => {
    setDraggedField({
      field,
      value,
      fieldType,
      timestamp: Date.now()
    })
  }, [])

  const endDrag = useCallback(() => {
    setDraggedField(null)
  }, [])

  const value = {
    clipboard,
    copyField,
    pasteField,
    clearClipboard,
    canPaste,
    draggedField,
    startDrag,
    endDrag
  }

  return (
    <FieldClipboardContext.Provider value={value}>
      {children}
    </FieldClipboardContext.Provider>
  )
}

export function useFieldClipboard() {
  const context = useContext(FieldClipboardContext)
  if (!context) {
    throw new Error("useFieldClipboard must be used within a FieldClipboardProvider")
  }
  return context
}
